import React from 'react'
import { useParams, Link } from 'react-router-dom'
import styled from 'styled-components'
import { get } from '@ally/metronome-ui'
import { AccountDetails } from '../../../types'
import {
  addDays,
  getServerTimeShortDateWithoutYear,
} from '../../../utils/formatter'
import { ActionPromptItem } from './ActionPromptItem'

// Grace period starts from CD maturity date and is available for 10-days; customer has 9 days to make changes
const CD_GRACE_PERIOD = 9

// TODO - replace these react-router-dom links with metronome links when query string capability added
const StyledLink = styled(Link)`
  padding: 0;
  margin: 0;
  text-decoration: none;
  font-weight: bold;
  color: ${get.colors('bluesuedeshoes')};
`

export const RenewalBonusMessage: React.FC<{
  account: AccountDetails
}> = ({ account }) => {
  const { id } = useParams<{ id: string }>()

  const { inGracePeriod, lastCdMaturityDate } = account

  const loyaltyRateApplied =
    inGracePeriod && lastCdMaturityDate
      ? getServerTimeShortDateWithoutYear(
          addDays(lastCdMaturityDate, CD_GRACE_PERIOD + 1).toString(),
        )
      : ''

  const gracePeriodEnds =
    inGracePeriod && lastCdMaturityDate
      ? getServerTimeShortDateWithoutYear(
          addDays(lastCdMaturityDate, CD_GRACE_PERIOD).toString(),
        )
      : ''

  if (inGracePeriod) {
    return (
      <ActionPromptItem id="grace-period">
        We&apos;ll add your 0.05% loyalty reward to your interest rate on{' '}
        {loyaltyRateApplied}. You have until {gracePeriodEnds} to add money or
        change terms.{' '}
        <StyledLink to={`/bank/manage-cds?id=${id}`}>Manage your CD</StyledLink>
      </ActionPromptItem>
    )
  }
  return <></>
}
